import React from 'react'

export default function Lsb() {
  return (
    <div className="left-sidebar">
      <div className="sidebar-content">
        <img className="me" src="./assets/images/brijesh.jpg" alt="Brijesh Chavda"/>
        <div className="sidebar-header">
          <div className="name">
            <span className="first-name">Brijesh</span>
            <span className="last-name">Chavda</span>
          </div>
          <div className="title-container">
            <span className="title-divider"></span>
            <span className="designation">Distinguished Architect</span>
            <span className="title-divider"></span>
          </div>
        </div>
        <h2 className="email">
          <i className="las la-envelope"></i>
          <a href="mailto:brijesh.chavda@gmail.com">brijesh.chavda@gmail.com</a>
        </h2>
        <h2 className="address">
          <i className="las la-map-marker"></i>
          Bay area, CA
        </h2>
        <ul className="social-profile d-flex align-items-center flex-wrap justify-content-center">
          <li>
            <a href="https://www.linkedin.com/in/brijeshchavda/" target="_blank" rel="noopener noreferrer">
              <i className="lab la-linkedin"></i>
            </a>
          </li>
        </ul>
        <p className="copyright">&copy; 2025 Brijesh Chavda. All Rights Reserved</p>
      </div>
    </div>
  )
}   
